export class Author {
  constructor(public id: string, public name: string) {
  }
}
